/* GOLDSQUARE - pack size selection on the product card

   Lets a customer pick a pack size in the grid and buy it without
   opening the product page. The card's price, its strike-through, the
   Add to Cart button AND the hidden form input all follow the
   selection.

   ==== TWO PLACES HOLD THE VARIANT, AND BOTH MUST MOVE ====
   The card has two independent buy paths:

     Add to Cart   reads data-variant-id off the button (AJAX)
     Buy Now       posts the form's hidden input name="id"

   They are separate mechanisms and neither reads the other. Updating
   only the button would leave Buy Now posting whatever variant was
   rendered first - so a customer picks Pack of 5, presses Buy Now, and
   checks out with a Single. The page looks correct throughout, which
   is what makes it dangerous. Both are set below; do not remove one.

   ==== WHY EVENT DELEGATION ====
   Cards render in the homepage carousel, the collection grid, the cart
   cross-sell and "You may also like" on every product page. Several are
   re-rendered after load - the drawer uses the Section Rendering API,
   and the theme editor replaces whole sections. Binding per button
   would miss every card that appears later.

   Money goes through GS.money, which reads the shop's format from the
   [data-money-format] element in the header.
*/

(function () {
  'use strict';

  function money(cents) {
    if (window.GS && typeof GS.money === 'function') return GS.money(cents);
    return cents;
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var btn = e.target.closest('[data-card-variant]');
    if (!btn || btn.disabled) return;

    var card = btn.closest('.pcard');
    if (!card) return;

    var pills = card.querySelectorAll('[data-card-variant]');
    for (var i = 0; i < pills.length; i++) {
      pills[i].classList.remove('is-selected');
      pills[i].setAttribute('aria-pressed', 'false');
    }
    btn.classList.add('is-selected');
    btn.setAttribute('aria-pressed', 'true');

    var variantId = btn.getAttribute('data-variant-id');
    var price     = parseInt(btn.getAttribute('data-price'), 10) || 0;
    var compare   = parseInt(btn.getAttribute('data-compare'), 10) || 0;
    var available = btn.getAttribute('data-available') === 'true';

    var priceEl = card.querySelector('[data-card-price]');
    if (priceEl) priceEl.textContent = money(price);

    /* Only shown when the pack actually saves money - a strike-through
       equal to the price reads as a broken discount. */
    var compareEl = card.querySelector('[data-card-compare]');
    if (compareEl) {
      if (compare > price) {
        compareEl.textContent = money(compare);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    var saveEl = card.querySelector('[data-card-save]');
    if (saveEl) {
      if (compare > price) {
        saveEl.textContent = 'Save ' + Math.round((compare - price) * 100 / compare) + '%';
        saveEl.hidden = false;
      } else {
        saveEl.hidden = true;
      }
    }

    /* Path 1 - Add to Cart reads this attribute at click time. */
    var atc = card.querySelector('.pcard__atc');
    if (atc) {
      atc.setAttribute('data-variant-id', variantId);
      atc.disabled = !available;
      atc.textContent = available ? 'Add to Cart' : 'Sold Out';
    }

    /* Path 2 - Buy Now posts this input. See the note above. */
    var input = card.querySelector('[data-card-variant-input]');
    if (input) input.value = variantId;
  });
})();
